import { SitecoreTrialContentType } from '~/common/types';

export const premiumData: SitecoreTrialContentType = {
  title: 'Create an account',
  sku: 'LPPremiumTrial',
  formLogo: null,
  existingEmailError: '',
  logoutText: '',
  logoutLink: '',
  successLoggedInUrl: null,
  useDifferentEmail: '',
  notAllowedMessage: '',
  tryAgainError: '',
  inputs: {
    email: {
      options: null,
      label: 'Email *',
      type: 'email',
      id: 'email',
      defaultValue: '',
      required: true,
      error: 'Please enter a valid email address',
      placeHolder: 'Is this what you meant? ',
    },
    programName: {
      options: null,
      label: null,
      type: 'hidden',
      id: 'programName',
      defaultValue: 'GLB-WRQ-2025-04-Premium Trial Signup',
      required: false,
      error: null,
      placeHolder: null,
    },
    programID: {
      options: null,
      label: null,
      type: 'hidden',
      id: 'programID',
      defaultValue: '3444',
      required: false,
      error: null,
      placeHolder: null,
    },
  },
  sendButton: 'Start 30-day free trial',
  terms:
    'I accept the LastPass \u003Ca href="/legal-center/privacy-notice"\u003EPrivacy Policy\u003C/a\u003E&nbsp;&amp; \u003Ca href="/legal-center/terms-of-service/personal"\u003ETerms of Service\u003C/a\u003E. Please provide resources and promotional emails, including industry research, educational resources and solutions that are relevant to this topic. I understand I can \u003Cspan\u003Eunsubscribe\u003C/span\u003E at any time.',
  successUrl:
    'https://lastpass.com/create_account.php?premium=1&from=1&unifiedTrial=true&experiment_version=Unified_Trial',
  globalError: "Something doesn't look right. Please check that you've entered everything correctly.",
  footerText: '\u003Ca href="https://lastpass.com/?ac=1"\u003ELog in with existing account\u003C/a\u003E',
  successMessage: '',
  gaEventCategory: 'premium_trial-submit',
  gaEventAction: 'premium_trial',
  passwordInfo: '',
  optOutOfEmails: [
    {
      label: 'I prefer not to receive promotional emails.',
      type: 'checkbox',
      id: 'optout',
      defaultValue: '1',
      required: false,
      error: '',
      placeHolder: null,
    },
  ],
  errors: [
    {
      code: '1000',
      codeText: 'INVALID_SKU',
      message: 'Sku is not valid',
    },
    {
      code: '1001',
      codeText: 'INVALID_FORM_FIELD_VALUE',
      message: 'Please complete all required fields marked with an asterisk (*).',
    },
    {
      code: '2000',
      codeText: 'INCOMPATIBLE_ACCOUNT',
      message:
        'You can’t use that address to start a LastPass Premium trial. Go back and try again with a different email. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\r\n\u003cbr /\u003e\r\nError code: 2000',
    },
    {
      code: '2001',
      codeText: 'COMPANY_IS_MANAGED',
      message:
        'You can\u0027t use that address to start a LastPass Premium trial. Go back and try again with a different email. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\r\n\u003cbr /\u003e\r\nError code: 2001',
    },
    {
      code: '2002',
      codeText: 'BOSS_MIGRATION_RQUIRED',
      message:
        'We couldn\u0027t start your trial. Go back and try again. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\r\n\u003cbr /\u003e\r\nError code: 2002',
    },
    {
      code: '2003',
      codeText: 'TRIAL_NOT_AVAILABLE',
      message:
        'You can\u0027t use this email to create a new LastPass Premium trial. Go back and try again with an email that is not connected to LastPass. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\n\u003cbr /\u003e\n\nError code: 2003',
    },
    {
      code: '2004',
      codeText: 'NOT_AN_ADMIN_IN_GROUP_ACCOUNT',
      message:
        'You can\u0027t use that address to start a LastPass Premium trial. Go back and try again with a different email. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\r\n\u003cbr /\u003e\r\nError code: 2004',
    },
    {
      code: '2005',
      codeText: 'USER_DEACTIVATED',
      message:
        'You can\u0027t use this email to create a new LastPass Premium trial. Go back and try again with an email that is not connected to LastPass. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\n\u003cbr /\u003e\nError code: 2005',
    },
    {
      code: '2006',
      codeText: 'USER_AUTHENTICATION_REQUIRED',
      message:
        '\u003ca href="https://lastpass.com/?ac=1"\u003eLog in to your account \u003c/a\u003eto start a LastPass Premium trial. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\r\n\u003cbr /\u003e\r\nError code: 2006',
    },
    {
      code: '2007',
      codeText: 'Incomplete_registration',
      message:
        'It looks like you\u0027re already signed up. Look for an email from LastPass and verify your account. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\n\u003cbr /\u003e\nError code: 2007',
    },
    {
      code: '3001',
      codeText: 'FORBIDDEN_DOMAIN',
      message:
        'You can\u0027t use this email to create a new LastPass Premium trial. Go back and try again with an email that is not connected to LastPass. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\n\u003cbr /\u003e\nError code: 3001',
    },
    {
      code: '3002',
      codeText: 'INVALID_DOMAIN',
      message:
        'It looks like you entered an invalid or incomplete email address. Please go back and try again. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\n\u003cbr /\u003e\nError code: 3002',
    },
    {
      code: '3003',
      codeText: 'EMAIL_INVALID_FOR_REGISTRATION',
      message:
        'It looks like you entered an invalid or incomplete email address. Please go back and try again. \u003ca href="https://link.lastpass.com/premium-trial-error"\u003eLearn more\u003c/a\u003e\n\u003cbr /\u003e\nError code: 3003',
    },
    {
      code: '3004',
      codeText: 'Compliance_Checks_Registration',
      message:
        'Access or use of LastPass services in your region violates applicable export control and sanction laws and is prohibited.\n\u003cbr /\u003e\nError code: 3004',
    },
    {
      code: '1002',
      codeText: 'INVALID_FLOW_TYPE',
      message: '',
    },
  ],
  title2: '',
  backButton: '',
  sendButton2: '',
};
